import "./GameScreen.scss";
import "./StartingScreen.scss";
import initialData from "../quest_script.json";

function StartingScreen(props) {
  return (
    <>
      <div>
        <img
          className="starting_screen__image"
          src={`../assets/${initialData[22].image}`}
          alt="Инвестпанк 2077"
        ></img>
        <div className="starting_screen__description">
          <img
            className="dialog__description_top_line"
            src="../assets/descriptionTopLine.png"
            alt="Description Top Line"
          ></img>
          <img
            className="dialog__description_bar_left"
            src="../assets/descriptionBarLeft.png"
            alt="Description Bar Left"
          ></img>
          <div className="dialog__description_text">
            2077 год. Игровая индустрия захватила мир: в твоем детстве геймеров
            называли лузерами, а теперь они — миллиардеры.
            <span className="ending_screen__description-red">
              {" "}
              Выбирай, в какие компании будешь вкладываться, и проверь свой
              скилл видеоигрового инвестора.
            </span>
          </div>
        </div>
      </div>
      <div className="starting_screen__robot_line">
        <img
          className="starting_screen__robot_line_plate-top"
          src="../assets/robotLinePlate1.png"
          alt="Robot Line Element 1"
        />
        <img
          className="starting_screen__robot_line_background"
          src="../assets/plates/smallPlateRight.png"
          alt="Robot Line Plate"
        />
        <div className="starting_screen__robot_line_text">
          <span className="starting_screen__robot_line_text-red">ПОГНАЛИ,</span>
          <br />
          нажми на любую кнопку, чтобы начать!
        </div>
        <img
          className="starting_screen__robot_line_plate-bottom"
          src="../assets/robotLinePlate2.png"
          alt="Robot Line Element 2"
        />
      </div>
      <div className="starting_screen__info ">
        <img
          className="starting_screen__attention"
          src="../assets/attention.png"
          alt="Attention"
        />
        {initialData[22].attention}
      </div>
      <div className="starting_screen__button">
        <button
          className="starting_screen__button_anykey"
          onClick={props.onStartGame}
        ></button>
        <div className="starting_screen__button_text">{"ЛЮБАЯ КНОПКА!"}</div>
      </div>
    </>
  );
}

export default StartingScreen;
